export const NO_FORM_STATUS = ['planned'];
